import React from "react";

import { Button } from "~/components/button";

import { DataError } from "../components/react/data-error/DataError";

export const LoadingStackStateErrorScreen: React.FC = () => (
	<div className="absolute inset-0 z-9999">
		<DataError
			button={
				<Button
					className="uppercase"
					data-testid="error-loading-stackstate-button"
					onClick={() => location.reload()}
					variant="primary"
				>
					Reload Page
				</Button>
			}
			data-testid="error-loading-stackstate"
			header="Something went wrong"
		>
			Whoops, it looks like we are having trouble receiving data.
			<br />
			Please contact your administrator or wait a few minutes and try to reload the page...
		</DataError>
	</div>
);
